import type { DirectusCompany } from '@/types/directus-types'
import { directusReadSingletonItem } from './helperFunctions'

/** API Call to fetch the company details from the DB.
 *
 * @returns a user `CompanyData` object if successful. Undefined if not.
 */
export async function fetchFleetData(): Promise<DirectusCompany | undefined> {
  const collection = 'Company'
  const query = {
    fields: ['Name', 'Logo'],
  }

  const res = await directusReadSingletonItem<DirectusCompany>({ singleton: collection, query })
  return res
}

